<template>
  <ppt-slide-viewer module-code="ts_rb" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "TsRb",
  components: { PptSlideViewer }
};
</script>
